(function () {
	const elId = '#app-user';

	if ($(elId).length == 0) {
		return;
	}

	/* eslint-disable-next-line  no-new */
	var app = new Vue({
		mixins: [window.vueMountedCreatedMixin],
		el: elId,
		data: {
			twofactor: {
				password: null,
				pin: null,
				settings: {}
			},
			setup: false,
			response: null,
		},
		mounted: function () {
			window.toggleLoader(false);
		},
		created: function () {
			if (document.location.href.indexOf('?setupTwoFactor') > 0) {
				this.setup = true;
			}
			this.getTwoFactorSettings()
		},
		methods: {
			setupTwoFactor: function () {
				var self = this;
				self.response = null;
				var key = $('#twofactorimage').data('key');
				console.log(key, this.twofactor.pin)
				POST('/auth/checktwofactorpin', { pin: this.twofactor.pin, key: key }).then(function (xhr) {
					console.log(xhr.responseText, xhr);
					var response = JSON.parse(xhr.responseText);
					if (response.result) {
						var json = {
							userGuid: window.nominowUserguid,
							password: self.twofactor.password,
							enabled: true,
							key: key
						}
						PUT('/baas/nominow_management/twofactorsettings', json).then(function (xhr2) {
							var response2 = JSON.parse(xhr2.responseText);
							self.response = response2;

						}, window.trapError);
					}
				});
			},
			getTwoFactorSettings: function () {
				var self = this;
				GET('/baas/nominow_management/twofactorsettings?userGuid=' + window.nominowUserguid).then(function (xhr) {
					var result = JSON.parse(xhr.responseText);
					self.twofactor.settings = result;
					if (self.twofactor.settings.TwoFactorEnabled) {
						self.setup = true;
					}
				}, window.trapError);

			}
		}
	});

	window.activeRootComponent = app;
})();
